<template>
  <Modal id="materials-crop" @close="handlerClose">
    <h2>{{ $t('ModalPhotoCrop') }}</h2>
    <VueCropper :src="src" :aspect-ratio="1" ref="cropper" v-if="src" />

    <div class="actions">
      <button class="primary" @click="save">{{ $t('crop') }}</button>
      <button @click="closeModal">{{ $t('close') }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import { mapMutations } from 'vuex'

export default {
  name: 'ModalPhotoCrop',
  components: { VueCropper, Modal },
  model: {
    prop: 'src',
    event: 'change',
  },
  props: {
    src: {},
  },
  methods: {
    handlerClose() {
      this.clean()
      this.$emit('close')
    },
    save() {
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        this.$emit('change', blob)
      })
      this.closeModal()
    },
    clean() {
      if (this.$refs.cropper) {
        this.$refs.cropper.clear()
      }
    },
    ...mapMutations(['closeModal']),
  },

  watch: {
    src(src) {
      if (src && this.$refs.cropper) {
        this.$refs.cropper.replace(src)
      }
    },
  },
}
</script>

<style lang="scss">
#modal-materials-upload {
}
</style>
